import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SiteHeaderDesktopV2 from '../SiteHeaderDesktop.top_nav_tweaks';
import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderDesktopContainer from './SiteHeaderDesktop.container';

export default withFeatureBranch({ top_nav_tweaks: SiteHeaderDesktopV2 })(
  SiteHeaderDesktopContainer(SiteHeaderDesktop)
);
